// Authoritative trader-login allowlist. Admins always have access. Non-admin `user`
// logins listed here are traders. Add new trader logins here. Any `user` NOT listed
// is treated as a client and is fully excluded (nav + route).
export const TRADER_LOGINS: string[] = ['Ivan_E_trader', 'night_1_user', 'night_2_user'];

export const canSeeTraderArea = (u?: { role: string; login: string } | null): boolean =>
  !!u && (u.role === 'admin' || TRADER_LOGINS.includes(u.login));
